if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            
             // 💡 Add this line right after setting innerHTML
            this.addChooseOptionsHeading();
            this.initImageSlider();

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }

    addChooseOptionsHeading() {
      const modal = this.modalContent;
    
      // Prevent adding the heading more than once
      if (modal.parentElement.querySelector('h2.choose-options')) return;
    
      // Find the toggle element
      const toggleElement = modal.parentElement.querySelector('.quick-add-modal__toggle');
    
      if (toggleElement) {
        const heading = document.createElement('h2');
        heading.textContent = 'Choose Options';
        heading.classList.add('choose-options');
    
        // Insert the heading before the toggle element
        toggleElement.parentNode.insertBefore(heading, toggleElement);
      }
    }



      // initImageSlider() {
      //   const modal = this.modalContent;
      //   const mediaList = modal.querySelector('.product__media-list');
      //   const slidesCount = mediaList.querySelectorAll('.product__media-item').length; // Get the total number of slides

      //   console.log(slidesCount);
      
      //   // Ensure the mediaList exists
      //   if (!mediaList) {
      //     console.error('Media list not found.');
      //     return; // Exit if the media list is not found
      //   }
      
      //   // Ensure Slick only initializes once
      //   if (!mediaList.classList.contains('slick-initialized')) {
          
      //     const slideControls = document.querySelector('.wbc-product-slider-controls');
      //     const grid_modal = document.querySelector('.quick-add-modal .product.grid');
      
      //     // If there's only one slide, destroy the slider
      //     if (slidesCount <= 2) {
      //       $(mediaList).addClass('no-slider');
      //       // Check if Slick has been initialized
      //       if ($(mediaList).hasClass('slick-initialized')) {
      //         $(mediaList).slick('unslick'); // Destroy the slick slider
      //       }
      //       // Remove the slide controls if they exist
      //       if (slideControls) {
      //         grid_modal.style.gap = '40px';
      //         slideControls.remove();
      //       }
      //       return; // Exit the function so that Slick doesn't get initialized
      //     } else {
      //         // Define base settings for Slick
      //         let slickSettings = {
      //           slidesToShow: 1, // Number of slides to show at a time
      //           slidesToScroll: 1, // Number of slides to scroll at once
      //           arrows: true, // Show navigation arrows
      //           prevArrow: modal.querySelector('#wbc-product-slider-left'), // Custom left arrow
      //           nextArrow: modal.querySelector('#wbc-product-slider-right'), // Custom right arrow
      //           dots: true, // Show dots for navigation
      //           infinite: true, // Infinite scrolling (loop back to the start after the last slide)
      //           autoplay: false, // Set to true if you want autoplay
      //           autoplaySpeed: 3000, // How long each slide should be visible (in milliseconds)
      //           fade: false, // Set to true for a fade effect between slides
      //           speed: 500, // Speed of the slide transition (in milliseconds)
      //           centerMode: true,
      //           centerPadding: '60px',
      //           responsive: [
      //             {
      //               breakpoint: 749,
      //               settings: {
      //                 slidesToShow: 2, // If there are multiple slides, show 2
      //                 slidesToScroll: 1,
      //                 dots: false,
      //                 centerMode: false,
      //                 centerPadding: '0', // Smaller padding on mobile
      //               }
      //             }
      //           ]
      //         };
            
      //       // Initialize Slick with the settings
      //       $(mediaList).slick(slickSettings);
        
      //       function setSlideVisibility() {
      //         // Find the visible slides (i.e., where aria-hidden="false")
      //         var visibleSlides = $(mediaList).find('.slick-slideshow__slide[aria-hidden="false"]');
      //         // Make sure all of the visible slides have an opacity of 1
      //         $(visibleSlides).each(function() {
      //           $(this).css('opacity', 1);
      //         });
        
      //         // Set the opacity of the first and last partial slides
      //         $(visibleSlides).first().prev().css('opacity', 0);
      //       }
        
      //       $(mediaList).slick('slickGoTo', 1);
      //       // setSlideVisibility();
        
      //       $(mediaList).on('afterChange', function() {
      //         setSlideVisibility();
      //       });
      //     }
      //   }
      // }

      initImageSlider() {
        const modal = this.modalContent;
        const mediaList = modal.querySelector('.product__media-list');

        const slidesCount = mediaList.querySelectorAll('.product__media-item').length;
      
        // Ensure the mediaList exists
        if (!mediaList) {
          console.error('Media list not found.');
          return;
        }
      
        const screenWidth = window.innerWidth;
        const shouldInitSlider =
          (screenWidth > 749 && slidesCount > 1) || (screenWidth <= 749 && slidesCount > 2);
      
        // Ensure Slick only initializes once
        if (!mediaList.classList.contains('slick-initialized')) {
          const slideControls = document.querySelector('.wbc-product-slider-controls');
          const grid_modal = document.querySelector('.quick-add-modal .product.grid');
      
          if (!shouldInitSlider) {
            $(mediaList).addClass('no-slider');

            if (slidesCount === 1) {
              $(mediaList).addClass('no-slider-only-one');
            }
      
            if ($(mediaList).hasClass('slick-initialized')) {
              $(mediaList).slick('unslick');
            }
      
            if (slideControls) {
              grid_modal.style.gap = '40px';
              slideControls.remove();
            }
      
            return;
          } else {
            let isLandscape = window.matchMedia("(orientation: landscape)").matches;
            let isSmallScreen = window.innerWidth < 1280;
            let isLandscapeAndSmall = isLandscape && isSmallScreen;

            let slickSettings = {
              slidesToShow: isLandscapeAndSmall ? 2 : 1,
              slidesToScroll: 1,
              arrows: true,
              prevArrow: modal.querySelector('#wbc-product-slider-left'),
              nextArrow: modal.querySelector('#wbc-product-slider-right'),
              dots: false,
              infinite: true,
              autoplay: false,
              autoplaySpeed: 3000,
              fade: false,
              speed: 500,
              centerMode: true,
              centerPadding: '60px',
              responsive: [
                {
                  breakpoint: 749,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: false,
                    centerMode: false,
                    centerPadding: '0',
                  }
                }
              ]
            };
      
            $(mediaList).slick(slickSettings);
      
            function setSlideVisibility() {
              const visibleSlides = $(mediaList).find('.slick-slideshow__slide[aria-hidden="false"]');
              $(visibleSlides).each(function () {
                $(this).css('opacity', 1);
              });
      
              $(visibleSlides).first().prev().css('opacity', 0);
            }
      
            $(mediaList).slick('slickGoTo', 1);
      
            $(mediaList).on('afterChange', function () {
              setSlideVisibility();
            });
          }
        }
      }

    }
  );
}
